module.exports = __webpack_public_path__ + "img/klienci.d21a327e.svg";